import axios from '@/libs/api.request'

// ========== 人群包管理接口 ==========
// Base path: /crowd-pack

// GET - 人群包分页查询
// Params: current, size, name, countryCodes, langIds, registerTimeType, payType, deviceSys
export const getCrowdList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/crowd-pack'
  })
}

// POST - 新增人群包
// Body: { name, countryCodes[], langIds[], deviceSys(0=iOS,1=Android), channels[],
//   payType(0=未付费,1=已付费), registerTimeCompareType(1=>=,2=<=,3=区间),
//   registerTimeMin(小时), registerTimeMax(小时), todayLogin(boolean),
//   watchAdNumCompareType/watchAdNumMin/watchAdNumMax,
//   watchDurationCompareType/watchDurationMin/watchDurationMax,
//   continuousLoginDaysCompareType/continuousLoginDaysMin/continuousLoginDaysMax }
export const addCrowd = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/crowd-pack'
  })
}

// PUT - 编辑人群包
// Body: { id, ...same as add }
export const editCrowd = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/crowd-pack'
  })
}

// GET - 根据id获取人群包详情
export const getCrowdInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/crowd-pack/' + id
  })
}

// DELETE - 删除人群包
export const delCrowd = (id) => {
  return axios.request({
    method: 'delete',
    url: '/crowd-pack/' + id
  })
}

// GET - 获取注册时间筛选选项（从已有记录中汇总去重）
export const getRegisterTimeOptions = () => {
  return axios.request({
    method: 'get',
    url: '/crowd-pack/register-time-options'
  })
}

// GET - 查看人群包使用情况
// Response: { popupPushItems[], thirdPayItems[], adStrategyItems[], abTestItems[] }
// Each item: { refId, refName, status }
export const getCrowdUsage = (id) => {
  return axios.request({
    method: 'get',
    url: '/crowd-pack/' + id + '/usage'
  })
}
